export default __webpack_public_path__ + "images/N7.ae1258f.png";